import { DtoApiPager } from "./abst/DtoApiPager";
import { DtoConditionsGetRes } from "./abst/DtoConditionsGetRes";

export class DtoConditionsGetResImple extends DtoConditionsGetRes {
  public pager = new DtoApiPager();
}
